import axios from 'axios';

export default class UploadAdapter {
    constructor(loader, uploadUrl = '/images/upload') {
        this.loader = loader;
        this.uploadUrl = uploadUrl;
    }

    upload() {
        return this.loader.file
            .then(file => new Promise((resolve, reject) => {
                const data = new FormData();
                data.append('upload', file);

                const url = process.env.VUE_APP_API_BASE_URL + this.uploadUrl;
                const token = localStorage.getItem('vue-authenticate.vueauth_access_token');

                axios.post(url, data, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    },
                    onUploadProgress: progressEvent => {
                        this.loader.uploadTotal = progressEvent.total;
                        this.loader.uploaded = progressEvent.loaded;
                    }
                })
                    .then(response => {
                        console.log(response)
                        resolve({
                            default: response.data.url
                        });
                    })
                    .catch(error => {
                        reject(error.response?.data?.message || 'Error uploading file');
                    });
            }));
    }

    abort() {
    }
}
